//Gewinnspiel
if ($("#ttgGewinnspielForm .google-recaptcha").length) {
    $('#ttgGewinnspielForm .recaptcha-consent input[type="checkbox"]').on('change', function() {
        if ($(this).is(':checked')) {
            var sitekey = $("#ttgGewinnspielForm").find('.google-recaptcha').data('sitekey');
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackGewinnspiel&render=' + sitekey;
            script.setAttribute('defer', '');
            head.appendChild(script);
        }
    });
}

var onloadCallbackGewinnspiel = function() {
    grecaptcha.ready(function() {
        grecaptcha.execute($("#ttgGewinnspielForm").find('.google-recaptcha').data('sitekey'), {
            action: 'submitGewinnspiel'
        }).then(function(token) {
            $('#ttgGewinnspielForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
        });
    });
};


/* PARSLEY */
$('#ttgGewinnspielForm').parsley();

/*  Teilnahmebedingungen */
$('.ttgTeilnahmeBedingungenLink').click(function() {
    if ($('.ttgGewinnspielTeilnahmebedingungen').length) {
        $('.ttgGewinnspielTeilnahmebedingungen').animatescroll({
            padding: 150
        });
    }
});

$('#agb').change(function() {
    if ($('#anforderungen').is(':checked')) {
        $('#agb').removeClass('invalid');
        $('#agb').addClass('valid');
    }
});

$('#check').change(function() {
    if ($('#indivCheck').is(':checked')) {
        $('#check').removeClass('invalid');
        $('#check').addClass('valid');
    }
});

/*  Check ob Radiobuttons gesetzt worden sind */
$('input:radio').change(function() {
    $(this).parents('fieldset').removeClass('invalid');
    $(this).parents('fieldset').addClass('valid');
});

/*  Check Field direkt nach Eingabe */
$('#ttgGewinnspielForm .required').blur(function() {
    checkField($(this).attr('id'));
});

/*  Change bei offener Frage */
$('#offeneFrage').change(function() {
    if ($(this).val()) {
        $(this).removeClass('invalid');
        $(this).addClass('valid');
    }
});

if ($('#ttgGewinnspielForm.matomoCheck').length) {
    if ($('#matomoTracking').length) {
        var visitor_id;
        _paq.push([function() {
            visitor_id = this.getVisitorId();
        }]);
        if (visitor_id) {
            $.ajax({
                type: "POST",
                url: '/index.php?id=' + rootPage + '&type=654322&L=0',
                data: {
                    visitor_id: visitor_id,
                    page_id: $('body').data('pid'),
                    url: $(location).attr('href').replace("https://", "")
                },
                dataType: 'json',
                success: function(result) {

                    if (result.participated == true) {
                        $('#ttgGewinnspielForm.matomoCheck').remove();
                        $('#matomoError .content').fadeIn();
                    }
                },
                error: function(xhr, status, error) {
                    console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', status);
                }
            });
        }
    }
}

/*  ######## SUBMIT ######## */
/*  Check Form bei Submit */
$('#ttgGewinnspielSenden').click(function(e) {
    /*  Check Fields */
    $('#ttgGewinnspielForm .required').each(function(i) {
        checkField($(this).attr('id'));
    });

    /*  Check ob Radiobuttons gesetzt worden sind */
    if ($('fieldset#antwort1').length) {
        var element = $('fieldset#antwort1');
        if (element.find("input:checked").length == 0) {
            element.addClass('invalid');
        }
    }

    if ($('fieldset#antwort2').length) {
        var element = $('fieldset#antwort2');
        if (element.find("input:checked").length == 0) {
            element.addClass('invalid');
        }
    }

    if ($('fieldset#antwort3').length) {
        var element = $('fieldset#antwort3');
        if (element.find("input:checked").length == 0) {
            element.addClass('invalid');
        }
    }

    if ($('#offeneFrage').length) {
        var element = $('#offeneFrage');
        if (!element.val()) {
            element.addClass('invalid');
        }
    }

    /* PARSLEY */
    if ($('#ttgGewinnspielForm').find('ul.filled').length != 0) {
        return;
    }


    /*  Check ob Klasse invalid vorhanden >> ERROR */
    if ($('#ttgGewinnspielForm').find('.invalid').length) {
        return false;
    } else {

        /*  FORMULAR KORREKT */
        /*  Leere noch vorhandene Standardwerte */
        $('#ttgGewinnspielForm input').each(function(i) {
            if ($(this).val() == $(this).attr('title')) {
                $(this).val('');
            }
        });

        /* den Button auf disabled setzen um 2x abzuschicken zu verhindern */
        setTimeout(() => {
            $('#ttgGewinnspielSenden').attr('disabled', 'disabled');
        }, 50);

        e.preventDefault();

        /*  Formular absenden – vorher frisches reCAPTCHA-Token holen, da v3-Tokens nur 2 Minuten gültig sind
            und das Token vom Consent-Klick beim Absenden oft schon abgelaufen ist (timeout-or-duplicate) */
        if (window.grecaptcha && $("#ttgGewinnspielForm .google-recaptcha").length) {
            grecaptcha.execute($("#ttgGewinnspielForm").find('.google-recaptcha').data('sitekey'), {
                action: 'submitGewinnspiel'
            }).then(function(token) {
                $('#ttgGewinnspielForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
                $('#ttgGewinnspielForm').submit();
            }).catch(function() {
                /*  Fallback: mit altem Token absenden statt Formular hängen zu lassen */
                $('#ttgGewinnspielForm').submit();
            });
        } else {
            $('#ttgGewinnspielForm').submit();
        }
    }
});

/*  leere Eingabefeld wenn Standardwert */
$('#ttgGewinnspielForm input, #ttgGewinnspielForm textarea').focus(function() {
    if ($(this).val() == $(this).attr('title')) {
        $(this).val('');
    }
});

/*  fülle Eingabefeld mit Standartwert wenn keine Eingabe */
$('#ttgGewinnspielForm input, #ttgGewinnspielForm textarea').blur(function() {
    if (!$(this).val()) {
        $(this).val($(this).attr('title'));
    }
});

/*  Function checkFields */
function checkField(id) {

    /*  Teilnahmebedingungen */
    if ($('#anforderungen').is(':checked')) {
        $('#agb').removeClass('invalid');
        $('#agb').addClass('valid');
    } else {
        $('#agb').addClass('invalid');
    }
    /*  Teilnahmebedingungen */
    if ($('#indivCheck').is(':checked')) {
        $('#check').removeClass('invalid');
        $('#check').addClass('valid');
    } else {
        $('#check').addClass('invalid');
    }
    /*  reCaptcha */
    if ($('#recaptchaConsentGewinnspiel').is(':checked')) {
        $('#recaptchaConsentGewinnspiel').parent().removeClass('invalid');
        $('#recaptchaConsentGewinnspiel').parent().addClass('valid');
    } else {
        $('#recaptchaConsentGewinnspiel').parent().addClass('invalid');
    }

    var element = $('#' + id);
    var value = element.val(); /*  aktueller Wert */
    var title = element.attr('title'); /*  Standardwert */

    /*  Check ob Standardwert oder leer >> ERROR */
    if ((value == title) || !value) {
        element.addClass('invalid');
        if (element.attr('id') == "ort" || element.attr('id') == "person_anrede") {
            element.next().addClass('invalid');
        }
    } else {
        /*  Spezieller Check für eMail Feld */
        if (id == "mail") {
            /*  Check auf korrekte eMail-Adresse */
            var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{ldelim}2,4{rdelim}$/;
            if (reg.test(value)) {
                element.removeClass('invalid'); /*  eMail-Adresse korrekt */
                element.addClass('valid');
            } else {
                element.addClass('invalid'); /*  eMail-Adresse unkorrekt >> ERROR */
            };
        } else {
            element.removeClass('invalid');
            element.addClass('valid');
        }
    }

}

function recaptchaCallbackGewinnspiel() {
    $('#ttgGewinnspielSenden').removeAttr('disabled');
};
